export const SET_LOGGED_IN = 'Set Logged In'
export const SET_USER = 'Set User'
export const SET_TOKEN = 'Set Token'
export const SET_REFRESH_TOKEN = 'Set Refresh Token'
export const SET_CURRENT_ORGANIZATION = 'Set Practitioner'
export const SET_ORGANIZATIONS = 'Set Practitioner Organizations'
export const SET_CURRENT_ORGANIZATION_ROLE = 'Update Practitioner Role'
